import React from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://allstarxperience.ca";
const DEFAULT_IMAGE = `${SITE_ORIGIN}/logo512.png`;

export default function SEO({ title, description, noindex = false, image, keywords }) {
  const { pathname } = useLocation();
  const url = `${SITE_ORIGIN}${pathname}`;
  const ogImage = image || DEFAULT_IMAGE;
  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}
